import React from "react";
import Grid from "@material-ui/core/Grid";
import Skeleton from '@material-ui/lab/Skeleton';

export default function SkeletonCardManager(props) {
  return (
    <React.Fragment>
      <Grid item>
        <Skeleton animation="wave" variant="rect" width={424} height={276} style={{ borderRadius: 16 }} />
      </Grid>

      <Grid item>
        <Skeleton animation="wave" variant="rect" width={424} height={276} style={{ borderRadius: 16 }} />
      </Grid>

      <Grid item>
        <Skeleton animation="wave" variant="rect" width={424} height={276} style={{ borderRadius: 16 }} />
      </Grid>

      <Grid item>
        <Skeleton animation="wave" variant="rect" width={424} height={276} style={{ borderRadius: 16 }} />
      </Grid>
    </React.Fragment>
  )
}